import { REFERENCE_FIELD_OPTIONS_CREATE } from '~/values/enums';

const request = async () => {
    const result = REFERENCE_FIELD_OPTIONS_CREATE.reduce((acc, group, idx) => {
        if (group.label && group.options.length) {
            acc.push({ key: `__group_${idx}`, label: `--- ${group.label} ---`, disabled: true });
            acc.push(...group.options);
        }
        return acc;
    }, []);

    return { result };
};

export default request;
